
import Cardinality1 from '@img/Cardinalite_n_1.png';
import Cardinality2 from '@img/Cardinalite_1_n.png';
import Cardinality3 from '@img/Cardinalite_n_n.png';
import Cardinality4 from '@img/Cardinalite_1_1.png';
import Concatenation from '@img/Concatenation.png';
import Value from '@img/Valeur.png';
import Count from '@img/Nombre.png';
import None from '@img/Sans_Agregation.png';
// import Image from 'next/image';
import { TW_AppBlogArticle, TW_AppblogArticleIcons, TW_AppBlogArticleImage, TW_AppBlogParagraphMargin } from '@utils/twClasses';

export default function Page() {

    return (
        <div className={TW_AppBlogArticle}>
            <h1 className="mb-6 text-3xl font-semibold text-black">
                Les différents types de champs
            </h1>
            <p className={TW_AppBlogParagraphMargin}>
                Maintenant que vous avez créé votre premier modèle de données et vos objets, vous allez pouvoir créer différents types de champs pour chaque objet selon vos besoins :
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Texte"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Vous pouvez renseigner dans ce champ toutes les informations que vous voulez, qu’elles soient textuelles ou numériques. Cependant, si vous l’utilisez pour stocker des nombres ou des dates, par exemple, vous ne bénéficierez pas des avantages des champs typés pour stocker ce type de données.
            </p>
            <div className={TW_AppBlogParagraphMargin}>
                Les champs peuvent être formatés de différentes façons :
                <ul className="list-disc list-inside">
                    <li>Pas de formatage</li>
                    <li>TOUT EN MAJUSCULE</li>
                    <li>tout en minuscule</li>
                    <li>Ou La Première Lettre De Chaque Mot En Majuscule</li>
                </ul>
                {/* <p>Si le formatage est retiré, les données reprennent leur forme telle que l'utilisateur les a renseignées à l'origine.</p> */}
            </div>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Texte multiligne"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Ce champ vous permet de renseigner des informations textuelles sur plusieurs lignes. À la différence du champ "Texte" qui affiche le texte de façon linéaire, l'utilisateur peut voir le texte sur plusieurs lignes et l'organiser comme il le souhaite.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Selon le champ que vous choisissez, le texte sera donc affiché différemment :
            </p>
            <p className={TW_AppBlogParagraphMargin}> <strong>Champ "Texte" :</strong> <br></br>24/09/2025 RDV avec Mr Dupont de la société XXX. Motif: Évaluation des besoins en matériel informatique.
            </p>
            <p className={TW_AppBlogParagraphMargin}> <strong>Champ "Texte multiligne" :</strong> <br></br> 24/09/2025<br></br> RDV avec Mr Dupont de la société XXX.<br></br> Motif: Évaluation des besoins en matériel informatique.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Nombre entier"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Remplissez ce champ avec des nombres entiers. Vous pouvez définir la façon dont les nombres sont affichés (séparateur des milliers).
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br> Quantité en stock d’un produit : 1 400 000 ou 1,400,000 ou 1.400.000
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Nombre décimal"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Remplissez ce champ avec des nombres décimaux. Vous pouvez définir la façon dont les nombres sont affichés (séparateur des milliers, séparateur de décimales, nombre de décimales).
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br>  Montant de facture : 3 507,6 ou 3,507.57 ou 3.507,570
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Devise"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Ce champ vous permet de renseigner des données monétaires. Vous pouvez choisir le formatage du champ, le nombre de décimales et le symbole ( €, $, USD…).
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br>  Prix d’un produit : 1 250,00 €, $ 1.250 ou € 1,250.00
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Case à cocher"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Ce champ est une simple case à cocher. Dans les vues, vous pouvez filtrer la donnée selon si oui ou non la case est cochée.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Date"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Ce champ permet de renseigner une date. Vous pouvez choisir le format de date parmi une liste de format prédéfini.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br>  Date de facturation : 14/05/2025, 14 mai 2025, mercredi 14 mai 2025, 14
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Période"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Utilisez ce champ pour définir une période. À la différence du champ date qui permet de définir un jour, le champ Période vous permet de choisir une semaine, un mois, un trimestre, ou encore une année.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br>  Déclaration TVA : Février 2025, T1 2025
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Choix"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Définissez autant d’options que vous le souhaitez. Lors de l’édition d’un champ de type “Choix”, vous ne pouvez choisir qu’une seule valeur.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br>  Type de contact : “Client”, “Prospect” ou “Fournisseur”
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Choix multiple"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Même principe que le champ “Choix”, à la différence qu’à l’édition du champ, vous pouvez sélectionner plusieurs valeurs pour ce champ.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br>  Caractéristiques produit : “Fauteuil”, “Vintage” et “Bleu”
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "Utilisateur"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Ce champ vous permet de sélectionner un utilisateur parmi les utilisateurs de Compozz.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Exemple :<br></br> Créé par : Nathan Mercier
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs “Pourcentage”
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Utilisez ce champ pour renseigner des pourcentages. De la même manière que pour les champs décimaux, vous pouvez choisir le formatage du champ.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs "URL"
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Ce champ vous permet de renseigner un lien URL cliquable. Vous pouvez choisir le formatage du champ comme pour un champ "Texte".<div className=""></div>
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Petite astuce si vous souhaitez que votre lien apparaisse sous un nom plutôt que l'URL elle-même, vous pouvez le faire en renseignant le nom générique suivi d'un "@", suivi de l'URL (nom@url) :
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                "Compozz@https://compozz.com/" apparaitra comme "Compozz" dans votre champ et vous ménera à la page https://compozz.com/ quand vous cliquerez dessus.
            </p>
            <h2 className="mb-4 text-2xl font-medium text-compozz-purple">
                Les champs “Relier à un autre objet”
            </h2>
            <p className={TW_AppBlogParagraphMargin}>
                Ce champ mérite qu’on s’y attarde un peu plus que sur les autres. Comme vous le savez maintenant, vos modèles de données reposent sur la création d’objets. Et tout l’intérêt de Compozz est de pouvoir mettre en lien ces objets pour agréger la donnée comme vous le voulez et mettre en avant les données importantes pour votre entreprise.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                C’est ce champ qui va vous permettre de lier vos objets. Dans un premier temps choisissez le champ de l’objet que vous souhaitez lier.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Une fois que vous avez sélectionné le champ que vous désirez lier, 3 informations sont à remplir :
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                <strong>Nom de la relation :</strong> Reprend par défaut le nom de l’objet que vous souhaitez lier, vous pouvez le modifier si besoin. Nommer la relation vous servira si vous souhaitez lier d’autres champs de ce même objet : en la réutilisant vous appliquerez automatiquement les paramètres de la relation à votre nouveau champ. Mais vous pouvez aussi avoir deux relations différentes qui relient les mêmes objets.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Objet 1 = Projets<br></br> Objet 2 = Collaborateurs
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                On crée un champ “Chef de Projet” dans l’objet Projet. Dans ce cas, un seul Collaborateur sera attribué au projet en tant que Chef de projet.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                On crée un champ “Membres de l’équipe” dans l’objet Projet. Dans ce cas, plusieurs Collaborateurs pourront être attribués au projet en tant que Membre de l’équipe.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                <strong>Cardinalité :</strong> Vous permet de définir plus précisément le lien qui unit les deux objets.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Des pictogrammes vous aident à faire votre choix. Voyons ensemble comment les lire.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                L’objet sur lequel vous êtes actuellement (Objet 1) est représenté à gauche du pictogramme. Celui que vous voulez lier (objet 2) est représenté à droite du pictogramme :
            </p>
            <div className='flex flew-row gap-3 mb-5 '>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality1} 
                    alt="Cardinality_many_to_one" 
                />
                <p className='content-center'>
                    Vous pouvez attribuer le même Objet 2 à plusieurs Objet 1. Un Objet 1 ne peut avoir qu’un Objet 2.
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Exemple :<br></br>Objet 1 = Projets<br></br>Objet 2 = Collaborateurs
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    On créé un champ de type Lien sur l’objet Projets. Ce champ servira à attribuer un Chef de projet au Projet. Un chef de projet peut s’occuper de plusieurs projets mais un projet n’est géré que par un seul chef de projet.
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    Le Projet A aura Collaborateur B comme Chef de projet<br></br>Le Projet B aura Collaborateur B comme Chef de projet<br></br>Le projet C aura Collaborateur A comme Chef de projet
                </p>
            </div>
            <div className='flex gap-3 align-center mb-5'>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality2} 
                    alt="Cardinality_one_to_many" 
                />
                <p className='content-center'>
                    Plusieurs Objet 2 peuvent être attribué au même Objet 1. Un Objet 2 ne peut avoir qu’un Objet 1
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Exemple :<br></br>Objet 1 = Managers<br></br>Objet 2 = Collaborateurs
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    On créé un champ de type Lien sur l’objet Managers. Ce champ servira à attribuer des collaborateurs au Manager. Un manager “manage” plusieurs collaborateurs mais un collaborateur n’a qu’un seul manager (direct).
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    Le Manager A aura dans son équipe le Collaborateur A et le Collaborateur B<br></br>Le Manager B aura dans son équipe le Collaborateur C<br></br>Les collaborateurs A, B et C ne peuvent pas être attribués à un autre Manager
                </p>
            </div>
            <div className='flex gap-3 align-center mb-5'>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality3} 
                    alt="Cardinality_many_to_many"
                />

                <p className='content-center'>
                    Plusieurs Objet 1 peuvent avoir plusieurs Objet 2.
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Exemple :<br></br>Objet 1 = Produits<br></br>Objet 2 = Caractéristiques
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    On créé un champ de type Lien sur l’objet Produits. Ce champ servira à attribuer des caractéristiques à chaque Produit. Un produit peut avoir plusieurs caractéristiques (couleur, type, taille…) et la même caractéristique peut être attribuées à plusieurs produits différents.
                </p>
                <p className={TW_AppBlogParagraphMargin}>
                    Le Produit A aura la Caractéristique A, B et C<br></br>Le Produit B aura la Caractéristique B et C<br></br>Le Produit C aura la Caractéristique A, B et C
                </p>
            </div>
            <div className='flex gap-3 align-center mb-5'>
                <img 
                    className={TW_AppblogArticleIcons} 
                    src={Cardinality4} 
                    alt="Cardinality_one_to_one" 
                />
                <p className='content-center'>
                    Un Objet 2 ne peut être attribué qu’à un Objet 1 et un Objet 1 ne peut avoir qu’un Objet 2.
                </p>
            </div>
            <div className='ml-5'>
                <p className={TW_AppBlogParagraphMargin}>
                    Exemple :<br></br>Objet 1 = Départements<br></br>Objet 2 = Chefs de Département
                </p>

                <p className={TW_AppBlogParagraphMargin}>
                    Le Départements A aura le Chef de Département B <br></br>Le Département B aura le Chef de Département A<br></br>Les Chefs de Département A et B ne pourront pas être attribués à d’autres Départements
                </p>
            </div>
            <p className={TW_AppBlogParagraphMargin}>
                <strong>Agrégation :</strong> Vous permet de définir comment la donnée va être affichée. Voyons les différentes possibilités plus en détail avec l’exemple suivant :
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                On crée un lien entre un objet “Collaborateurs” et un objet “Projets” à partir de l’objet “Projets”. On décide d’y afficher les prénoms des collaborateurs.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                On attribue au Projet A les Collaborateurs suivants : Thibaut Rousseau, Léna Piton, Valérie Ledru et Thibaut Bordet.
            </p>
            <ul className="list-disc list-inside mb-5">
                <li className="mb-2">Concaténation<br></br> Le projet A sera présenté en une seule ligne et dans le champ “Collaborateurs” nous auront les informations suivantes : “Thibaut”, “Léna” , “Valérie” et “Thibaut”.</li>
                <img src={Concatenation} alt="Aggregation1" className={TW_AppBlogArticleImage} />
                <li className="mb-2">Valeur<br></br> Le projet A sera présenté en plusieurs lignes, à savoir une ligne pour chaque valeur. Attention ici, on pourrait penser que dans notre cas nous aurions 4 lignes, une pour chaque collaborateur. En fait, nous n’en avons que 3, car nous avons 2 fois la valeur “Thibaut” dans notre champ Collaborateurs. Ainsi :
                    <ul className="list-none list-inside ml-5 mt-2">
                        <li>Ligne 1 : Projet A / “Thibaut”</li>
                        <li>Ligne 2 : Projet A / “Léna”</li>
                        <li>Ligne 3 : Projet A /”Valérie”</li>
                    </ul>
                </li>
                <img src={Value} alt="Aggregation1" className={TW_AppBlogArticleImage} />
                <li className="mb-2">Nombre<br></br> Le projet A sera présenté en une seule ligne et nous aurons dans le champ “Collaborateurs” le nombre de collaborateurs attribués au projet. Dans notre cas, ce sera donc “4”.</li>
                <img src={Count} alt="Aggregation1" className={TW_AppBlogArticleImage} />
                <li className="mb-2">Nombre distinct<br></br> Comme “Nombre”, le projet A sera présenté en une seule ligne, mais une valeur répétée n’est comptée qu’une fois : nous aurons dans le champ “Collaborateurs” le nombre de prénoms différents. Dans notre cas, ce sera donc “3”, car “Thibaut” apparaît 2 fois.</li>
                <li className="mb-2">Aucune agrégation<br></br> Le projet A sera présenté en 4 lignes, une pour chaque collaborateur. Nous aurons donc :
                    <ul className="list-none list-inside ml-5 mt-2">
                        <li>Ligne 1 : Projet A / “Thibaut”</li>
                        <li>Ligne 2 : Projet A / “Léna”</li>
                        <li>Ligne 3 : Projet A /”Valérie”</li>
                        <li>Ligne 4 : Projet A / “Thibaut”</li>
                    </ul>
                </li>
                <img src={None} alt="Aggregation1" className={TW_AppBlogArticleImage} />
            </ul>
            <p className={TW_AppBlogParagraphMargin}>
                Nous avons fait le tour des types de champ que vous pouvez utiliser dans Compozz. Si vous avez besoin d’informations complémentaires, n’hésitez pas à nous <a href="/freeTrial" className="text-compozz-purple hover:underline">contacter </a>!
            </p>
        </div>
    )

}